import classNames from 'classnames';
import * as React from 'react';

import { RenderHTML } from '../../../../../ReactComponents/RenderHTML';
import { ResponsivePicture } from '../../../../../ReactComponents/ResponsivePicture/ResponsivePicture';
import { TextColor } from '../../../../TextColor.csharp';
import { WidthVariant } from '../../../../WidthVariant.csharp';
import { FeaturedInfoProps } from './FeaturedInfoProps.csharp';

export const FeaturedInfo = (props: FeaturedInfoProps) => {
    const {
        narrowProfile,
        wideProfile,
        model: { heading, image, layout, link, text, textColor, narrowPictureProfile, widePictureProfile }
    } = props;

    const profile = layout == WidthVariant.OneColumn ? narrowProfile || narrowPictureProfile : wideProfile || widePictureProfile;

    const content = (
        <>
            {image && (
                <div className="FeaturedInfo__Image">
                    <ResponsivePicture profile={profile} model={image} />
                </div>
            )}
            <div className="FeaturedInfo__TextWrapper">
                {heading && <span className="FeaturedInfo__Heading">{heading}</span>}
                {text && <RenderHTML html={text} className="FeaturedInfo__Text" />}
            </div>
        </>
    );

    const blockClassNames = classNames(
        'FeaturedInfo',
        `FeaturedInfo--${TextColor[textColor]}`,
        `FeaturedInfo--${WidthVariant[layout]}`,
        !heading && !text && 'FeaturedInfo--WithoutText'
    );

    return (
        <div className={blockClassNames}>
            {link ? (
                <a href={link} className="FeaturedInfo__Link">
                    {content}
                </a>
            ) : (
                content
            )}
        </div>
    );
};
